/* CreationColor — mobiel menu: tabbladen Alle producten | Momenten & Thema's, met doorschuivende subcategorieën.
   Bouwt het menu uit dezelfde gegevens als het desktopmenu (.ccx-all-mega en .ccx-inspiratie-mega) en verbergt het standaard mobiele menu van het thema.
   Valt dit script weg, dan blijft het standaardmenu gewoon werken.
   SHOW_MOMENTEN: zet op true om de tab Momenten & Thema's weer te tonen. */
(function () {
  var SHOW_MOMENTEN = false;
  var mq = window.matchMedia('(max-width: 1024px)');
  var built = false;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function plain(node) {
    var c = node.cloneNode(true);
    $$('.ccx-badge,.ccx-soon-badge,svg', c).forEach(function (n) { n.parentNode.removeChild(n); });
    return (c.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function badgeOf(node) { var b = $('.ccx-badge', node); return b ? (b.textContent || '').trim() : ''; }
  function hrefOf(a) { return a ? (a.getAttribute('href') || a.getAttribute('data-href') || '') : ''; }
  function isDead(a, href) {
    if (!href || href === '#') return true;
    if (a && a.classList && a.classList.contains('ccx-soon')) return true;
    try { if (window.ccxIsSoon && window.ccxIsSoon(href)) return true; } catch (e) {}
    return false;
  }
  var CHEV = '<svg class="ccxm-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';

  /* rij-bouwers */
  function addBadge(row, text, cls) { if (text) row.appendChild(el('span', 'ccxm-badge ' + (cls || ''), text)); }
  function linkRow(label, href, o) {
    o = o || {};
    var dead = isDead(o.a, href);
    var r = dead ? el('div', 'ccxm-row ccxm-dead') : el('a', 'ccxm-row');
    if (!dead) r.href = href;
    if (o.cls) r.className += ' ' + o.cls;
    if (o.icon) r.appendChild(o.icon);
    if (o.thumb !== undefined) { var t = el('span', 'ccxm-th'); if (o.thumb) t.style.backgroundImage = o.thumb; r.appendChild(t); }
    var tx = el('span', 'ccxm-tx'); tx.appendChild(el('span', 'ccxm-lb', label));
    if (o.sub) tx.appendChild(el('span', 'ccxm-sb', o.sub));
    r.appendChild(tx);
    if (dead) addBadge(r, 'binnenkort', 'ccxm-soon'); else addBadge(r, o.badge, 'ccxm-b-' + (o.badge || '').toLowerCase());
    return r;
  }
  function navRow(label, o, onClick) {
    var r = el('button', 'ccxm-row'); r.type = 'button';
    if (o.icon) r.appendChild(o.icon);
    r.appendChild(el('span', 'ccxm-tx')).appendChild(el('span', 'ccxm-lb', label));
    addBadge(r, o.badge, 'ccxm-b-' + (o.badge || '').toLowerCase());
    r.insertAdjacentHTML('beforeend', CHEV);
    r.addEventListener('click', onClick);
    return r;
  }

  /* stapel met doorschuivende schermen */
  function Stack(root) { this.root = root; this.list = []; }
  Stack.prototype.base = function (screen) { this.root.appendChild(screen); this.list = [screen]; };
  Stack.prototype.push = function (screen) {
    var prev = this.list[this.list.length - 1];
    screen.classList.add('is-pre');
    this.root.appendChild(screen);
    this.list.push(screen);
    void screen.offsetWidth;
    screen.classList.remove('is-pre');
    if (prev) prev.classList.add('is-back');
    screen.scrollTop = 0;
  };
  Stack.prototype.pop = function () {
    if (this.list.length < 2) return;
    var topS = this.list.pop(), prev = this.list[this.list.length - 1];
    topS.classList.add('is-pre');
    if (prev) prev.classList.remove('is-back');
    setTimeout(function () { if (topS.parentNode) topS.parentNode.removeChild(topS); }, 320);
  };
  Stack.prototype.reset = function () { while (this.list.length > 1) this.pop(); };

  function screenWith(title, stack) {
    var s = el('div', 'ccxm-screen');
    if (title) {
      var h = el('div', 'ccxm-sh');
      var b = el('button', 'ccxm-back'); b.type = 'button'; b.setAttribute('aria-label', 'Terug'); b.innerHTML = BACK;
      b.addEventListener('click', function () { stack.pop(); });
      h.appendChild(b); h.appendChild(el('span', 'ccxm-st', title));
      s.appendChild(h);
    }
    return s;
  }

  function build() {
    if (built) return true;
    var drawer = $('#navigation-mobile');
    var wrap = drawer && $('.halo-sidebar-wrapper', drawer);
    var allMega = $('.ccx-all-mega');
    if (!wrap || !allMega) return false;
    var items = $$('.ccx-all-cat-list-item', allMega);
    if (!items.length) return false;

    var root = el('div', 'ccxm');

    /* zoeken */
    var sf = el('form', 'ccxm-search'); sf.action = '/search'; sf.method = 'get'; sf.setAttribute('role', 'search');
    sf.innerHTML = SEARCH + '<input type="search" name="q" placeholder="Zoek producten…" aria-label="Zoeken" autocomplete="off"><input type="hidden" name="type" value="product">';
    root.appendChild(sf);

    /* tabbladen */
    var tabs = el('div', 'ccxm-tabs'); tabs.setAttribute('role', 'tablist');
    var tAll = el('button', 'ccxm-tab on', 'Alle producten'); tAll.type = 'button';
    var tMom = el('button', 'ccxm-tab', 'Momenten & Thema’s'); tMom.type = 'button';
    tabs.appendChild(tAll); tabs.appendChild(tMom); root.appendChild(tabs);

    var panes = el('div', 'ccxm-panes'); root.appendChild(panes);

    /* ---- Pane 1: Alle producten ---- */
    var p1 = el('div', 'ccxm-pane'); var s1 = new Stack(p1); panes.appendChild(p1);
    var topScreen = el('div', 'ccxm-screen');
    s1.base(topScreen);
    items.forEach(function (item, idx) {
      var label = plain(item);
      var url = item.getAttribute('data-url') || '';
      var ic = null, iconSrc = $('.ccx-cat-icon', item);
      if (iconSrc) {
        ic = el('span', 'ccxm-ic'); ic.innerHTML = iconSrc.innerHTML;
        /* kleuren zoals op desktop: blauw, met groen (8e) en oranje (9e) */
        ic.style.backgroundColor = idx === 7 ? '#47ba00' : (idx === 8 ? '#f58e1e' : '#0b4f95');
      }
      var panel = document.getElementById(item.getAttribute('data-target'));
      var cols = panel ? $$('.ccx-all-cat-panel-col', panel) : [];
      if (!cols.length) { topScreen.appendChild(linkRow(label, url, { icon: ic })); return; }
      topScreen.appendChild(navRow(label, { icon: ic }, function () {
        var sc = screenWith(label, s1);
        if (url && url !== '#') sc.appendChild(linkRow('Alles in ' + label, url, { cls: 'ccxm-all' }));
        cols.forEach(function (col) {
          var h3 = $('h3', col), ha = h3 && $('a', h3);
          var cl = h3 ? plain(h3) : '', cb = h3 ? badgeOf(h3) : '', ch = hrefOf(ha);
          var gl = $$('ul li a', col).filter(function (a) { return !a.classList.contains('ccx-view-all'); });
          if (!gl.length) { sc.appendChild(linkRow(cl, ch, { a: ha, badge: cb })); return; }
          sc.appendChild(navRow(cl, { badge: cb }, function () {
            var s3 = screenWith(cl, s1);
            if (ch && ch !== '#') s3.appendChild(linkRow('Alles in ' + cl, ch, { cls: 'ccxm-all', a: ha }));
            gl.forEach(function (a) { s3.appendChild(linkRow(plain(a), hrefOf(a), { a: a, badge: badgeOf(a) })); });
            s1.push(s3);
          }));
        });
        s1.push(sc);
      }));
    });
    var minor = el('div', 'ccxm-minor');
    [['Klantenservice', '/pages/klantenservice'], ['Offerte aanvragen', '/pages/offerte-aanvragen']].forEach(function (x) {
      var a = el('a', 'ccxm-row ccxm-m', x[0]); a.href = x[1]; minor.appendChild(a);
    });
    topScreen.appendChild(minor);

    /* ---- Pane 2: Momenten & Thema's ---- */
    var p2 = el('div', 'ccxm-pane'); p2.hidden = true; panes.appendChild(p2);
    var inspTabs = $$('.ccx-insp-tab'), inspPanels = $$('.ccx-insp-panel');
    var seg = el('div', 'ccxm-seg'); p2.appendChild(seg);
    var lists = el('div', 'ccxm-stack'); p2.appendChild(lists);
    var segBtns = [], listEls = [];
    inspPanels.forEach(function (pn, i) {
      var name = inspTabs[i] ? plain(inspTabs[i]) : ('Tab ' + (i + 1));
      var b = el('button', 'ccxm-segb' + (i === 0 ? ' on' : ''), name); b.type = 'button';
      var l = el('div', 'ccxm-screen'); if (i) l.hidden = true;
      $$('.ccx-moment-tile', pn).forEach(function (t) {
        var bg = $('.ccx-moment-bg', t), tt = $('.ccx-moment-title', t), tg = $('.ccx-moment-tag', t);
        var img = bg ? (bg.style.backgroundImage || '') : '';
        l.appendChild(linkRow(tt ? plain(tt) : '', t.getAttribute('href') || '', { a: t, thumb: img, sub: tg ? plain(tg) : '' }));
      });
      b.addEventListener('click', function () {
        segBtns.forEach(function (x, j) { x.classList.toggle('on', j === i); listEls[j].hidden = (j !== i); });
        listEls[i].scrollTop = 0;
      });
      seg.appendChild(b); lists.appendChild(l); segBtns.push(b); listEls.push(l);
    });
    if (inspPanels.length < 2) seg.hidden = true;

    /* tabs schakelen */
    function show(which) {
      var a = which === 'all';
      tAll.classList.toggle('on', a); tMom.classList.toggle('on', !a);
      tAll.setAttribute('aria-selected', a ? 'true' : 'false'); tMom.setAttribute('aria-selected', a ? 'false' : 'true');
      p1.hidden = !a; p2.hidden = a;
    }
    tAll.addEventListener('click', function () { show('all'); });
    tMom.addEventListener('click', function () { show('mom'); });
    if (!SHOW_MOMENTEN || !inspPanels.length) { tMom.hidden = true; }

    /* voetbalk */
    var foot = el('div', 'ccxm-foot');
    foot.innerHTML = '<a class="ccxm-phone" href="tel:+31762055335"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>076 205 5335</a><span class="ccxm-rate"><b>★</b> 4,4 &middot; 300+ reviews</span>';
    root.appendChild(foot);

    wrap.appendChild(root);
    drawer.classList.add('ccxm-on');
    built = true;

    /* bij sluiten terug naar het hoofdscherm */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && (t.closest('[data-menu-close-sidebar]') || t.closest('.background-overlay') || t.closest('[data-close-sidebar]'))) {
        setTimeout(function () { s1.reset(); }, 400);
      }
    });
    return true;
  }

  function tryBuild() { if (mq.matches) build(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', tryBuild); } else { tryBuild(); }
  window.addEventListener('load', function () { tryBuild(); setTimeout(tryBuild, 600); setTimeout(tryBuild, 1800); });
  if (mq.addEventListener) mq.addEventListener('change', tryBuild);
})();
